<template>
    <div class="single-event">
        <PageTitle 
            title="" 
            :style="'background-image: url(&quot;' + pack.image + '&quot;);'"
        />

        <section class="info-section">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 text-center">
                        <div class="event-info d-flex align-items-start justify-content-center oswald">
                            <div class="thumb-container"></div>
                            <div class="content">
                                <div class="title h1">
                                    {{ pack.name }}
                                </div>

                                <div class="subtitle h3 light">
                                    {{ pack.location }}
                                </div>

                                <div class="subtitle h3 light">
                                    {{ pack.address }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-9 text-lg-center mt-3 pb-4">
                        <div class="row">
                            <div class="col-12">
                                <div class="mb-5" v-html="pack.description"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <template v-if="pack.status == 1">
            <VentaConRecinto
                v-if="pack.recinto"
                :pack="pack"
            />
        </template>    
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import VentaConRecinto from '@/components/frontend/packs/venta/con_recinto/VentaConRecinto';

    export default {
        props: {
            slug: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                pack: {}
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        created() {
            this.getPack();
        },
        methods: {
            getPack() {
                const params = {                    
                    filters: {
                        tid : this.configuracion.hash_teatro
                    },
                    slug: this.slug
                }

                this.$store.dispatch(this.config.getVuexAlias("front.packs.show"), params).then(res => {
                    this.pack = res.data.data;
                });
            }
        },
        components: {
            PageTitle, VentaConRecinto
        }
    }
</script>